var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"py-1 px-0 ma-0 elevation-2",attrs:{"width":"100%"}},[_c('v-card-title',{staticClass:"text-h5 justify-center"},[_vm._t("login-title")],2),_c('v-card-text',{staticClass:"pb-0"},[_vm._t("login-body")],2),_c('v-card-actions',{staticClass:"pt-0"},[_vm._t("login-actions")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }